<template>
	<div>
		<br/>
		<v-row
			class="px-6 mt-3 mt-md-6"
			justify="space-around"
			align="center"
		>
			<v-col
				cols="12"
				md="5"
				style="text-align: center"
			>
				<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d187917.83890143293!2d-83.05086506898363!3d42.614369888012135!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882521d734e74b4b%3A0xf1ac86c48ee5a7c0!2sFairfield%20Inn%20%26%20Suites%20by%20Marriott%20Detroit%20Chesterfield!5e0!3m2!1sen!2sus!4v1684889817541!5m2!1sen!2sus"
					:width="$vuetify.breakpoint.mobile ? 300 : 600"
					height="400"
					style="border:0;"
					allowfullscreen=""
					loading="lazy"
					referrerpolicy="no-referrer-when-downgrade"></iframe>

			</v-col>
			<v-col
				cols="12"
				md="5"
			>
				<v-card
					elevation="6"
				>
					<v-card-title>
						Fairfield Inn by Marriott
					</v-card-title>
					<v-card-text style="font-size: larger">
						<p>
							45800 Market Place Blvd<br/>
							Chesterfield, MI 48051
						</p>
						<p>
							In order to reserve a room, please call (586) 267-5300 and ask for the Schwartz Wedding block of rooms <em>or</em> use the link below for group code SSW.
						</p>
						<p>
							The Hotel is located roughly 20 minutes from Cherry Creek Golf Club, however a complimentary shuttle to and from the venue is provided
						</p>
					</v-card-text>
					<v-card-actions>
						<v-btn href="https://www.marriott.com/events/start.mi?id=1684959702829&key=GRP" target="_blank" color="primary" style="color: #383838">
							Hotel Website &nbsp; <v-icon>fa-solid fa-up-right-from-square</v-icon>
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
		<br/>
	</div>
</template>

<script>

	export default {
		name: "Accommodations"
	}
</script>

<style scoped>
	iframe {
		border-radius: 8px;
		box-shadow: 0 3px 5px -1px rgba(0, 0, 0, .2), 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12);
	}
</style>
